module.exports = __webpack_public_path__ + "img/sitter1.0efaab6c.jpg";